// components/SanityImg.jsx
import React, { useState, useMemo } from "react";
import imageUrlBuilder from "@sanity/image-url";
import { client } from "../lib/client";

const builder = imageUrlBuilder(client);
const urlFor = (src) => builder.image(src);

export default function SanityImg({
  image,            // the whole {asset} from your query (not just url)
  alt = "",
  priority = false, // set true only for the first/hero image
  className = "",
  sizes = "(max-width: 768px) 80vw, 40vw",
  maxW = 1200,      // cap max requested width
}) {
  const [loaded, setLoaded] = useState(false);

  // Derive responsive candidates
  const widths = [320, 480, 640, 800, 960, 1200].filter(w => w <= maxW);

  const srcSet = useMemo(() => {
    return widths
      .map((w) =>
        `${urlFor(image)
          .width(w)
          .fit("max")
          .auto("format")
          .url()} ${w}w`
      )
      .join(", ");
  }, [image, widths]);

  const src = useMemo(() =>
    urlFor(image).width(960).fit("max").auto("format").url(),
    [image]
  );

  const aspect = image?.asset?.metadata?.dimensions?.aspectRatio || (4/5);

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ aspectRatio: aspect }}
    >

      {/* Real image */}
      <img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover"
        loading={priority ? "eager" : "lazy"}
        fetchpriority={priority ? "high" : "auto"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 300ms ease" }}
      />
    </div>
  );
}
